module.exports = __webpack_public_path__ + "front/img/i5.338b85bf.png";